import React, { useState, useRef } from 'react';
import { faInfo, faUserPlus, faUserCheck, faUserMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../../assignments.scss';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip } from 'react-bootstrap';
import moment from 'moment';
import AssignmentSettings from '../../../../../components/AssignmentSettings';
import { useAssignmentContext } from '../../../context';
import {
  useAssignToSelfMutation,
  useUnAssignFromMeMutation,
  useReAssignToSelfMutation,
  useIsSelfAssignedMutation,
  useChangeModeMutation,
  useLazyGetAssignmentSettingsDetailsQuery
} from '../../../../../features/authentication/assignmentApislice';
import Modal from '../../../../../components/Modal';
import CustomToast from '../../../../../components/Toast';
import PropTypes from 'prop-types';
import { capitalizeFirstLetter } from '../../../utils';
import { useParams } from 'react-router';
import ActivityTypes from '../../../../../enums/activityTypes';
import ActivitySettings from '../../../../activities/components/ActivitySettings';
import { useActivityContext } from '../../../../activities/context';
import { useGetActivitySettingsMutation } from '../../../../../features/authentication/persistApiSlice';

const ConfirmModal = ({
  isOpen,
  onClose,
  titleName,
  contentWidth,
  onConfirmCallback,
  disableButton,
  messageContent
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      titleName={titleName}
      contentWidth={contentWidth}
      detailHeight={'auto'}>
      <div className="modal-details">
        <div>
          <p className="mb-0">
            {' '}
            <div dangerouslySetInnerHTML={{ __html: messageContent }}></div>
          </p>
        </div>
      </div>
      <div className="d-flex justify-content-center gap-2">
        <button className="btn btn-castleRed confirm-btn" onClick={onClose}>
          No
        </button>
        <button
          disabled={disableButton}
          className="btn btn-castleWhite confirm-btn"
          onClick={() => onConfirmCallback()}>
          Yes
        </button>
      </div>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  titleName: PropTypes.string,
  contentWidth: PropTypes.string,
  onConfirmCallback: PropTypes.func,
  messageContent: PropTypes.string,
  disableButton: PropTypes.bool
};
const SelfAssign = () => {
  const {
    assignmentId,
    startDate,
    endDate,
    showGrade,
    assignmentMode,
    availabilityOption,
    studentFileUpload,
    lockBrowser,
    photoMathBlock,
    autoStartCRUponGrading,
    timedHour,
    timedMinute,
    isTimed,
    setAssignmentMode,
    setAvailabilityOption,
    setAutoLockQuestions,
    setAllowAnswerChange,
    setShowGrade,
    setRetakesEnabled,
    setMasteryValue,
    setRetakeLimitValue,
    setIncludeCR,
    setUseProtractor,
    setCalculatorEnabled,
    setCalculatorType,
    setTextToSpeech,
    setStudentFileUpload,
    setAllowLangChange,
    setCrAnswerToolType,
    setIsTimed,
    setTimeOnTaskEnabled,
    setTimeOnTaskSeconds,
    setLockBrowser,
    setPhotoMathBlock,
    setAutoStartCRUponGrading,
    useRuler,
    setUseRuler,
    setTimedHour,
    setTimedMinute,
    crAnswerToolType,
    calculatorType,
    setInitialFromValue,
    setInitialToValue,
    allowAnswerChange
  } = useAssignmentContext();
  const [assignToMyself, setAssignToMyself] = React.useState(false);
  const [unAssignFromMe] = useUnAssignFromMeMutation();
  const [reAssignToSelf] = useReAssignToSelfMutation();
  const [isSelfAssigned] = useIsSelfAssignedMutation();
  const [reassignToMyself, setReassignToMyself] = useState(false);
  const [assignToSelf] = useAssignToSelfMutation();
  const [changeMode] = useChangeModeMutation();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [getAssignmentSettingsDetails, assignmentSettingsResult] =
    useLazyGetAssignmentSettingsDetailsQuery();
  const [confirmModalTitle, setConfirmModalTitle] = useState('');
  const [confirmModalMessage, setConfirmModalMessage] = useState('');
  const confirmModalCallbackRef = useRef();
  const [activitySettings, setActivitySettings] = useState(false);
  const [getActivitySettings] = useGetActivitySettingsMutation();
  const {activityType = ActivityTypes.Assignment } = useParams();
  const assignmentContext = useAssignmentContext();
  const activityContext = useActivityContext();
  const context = activityType == ActivityTypes.FlashCard ? activityContext : assignmentContext;

  React.useEffect(() => {
    if (assignmentId) {
      selfAsssignHandler();
      if(activityType == ActivityTypes.Assignment){
        fetchAssignmentSettingsDetails();
      }
      else
        getActivitySettingsAsync();
    }
  }, []);

  const selfAsssignHandler = async () => {
    isSelfAssigned({ assignmentId: assignmentId })
      .unwrap()
      .then((res) => {
        setAssignToMyself(res);
        setReassignToMyself(res);
      });
  };

  const getActivitySettingsAsync = async()=>{
    const persistData = await getActivitySettings().unwrap();
    setActivitySettings(persistData);
  };

  const fetchAssignmentSettingsDetails = async () => {
    try {
      const res = await getAssignmentSettingsDetails(assignmentId).unwrap();
      setAssignmentMode(() => {
        return res.assignmentMode === 'Quiz with score' ? 'quiz' : res.assignmentMode.toLowerCase();
      });
      setAvailabilityOption(res.availability);
      setAutoLockQuestions(res.autoLockQuestions);
      setAllowAnswerChange(res.allowAnswerChange);
      setShowGrade(res.showGrade);
      setRetakesEnabled(res.assignRetake);
      setMasteryValue(res.masteryLevel);
      setRetakeLimitValue(res.retakeLimit);
      setIncludeCR(res.includeCR);
      setUseProtractor(res.useProtractor);
      setCalculatorEnabled(res.useCalc);
      setCalculatorType(res.calculatorType);
      setTextToSpeech(res.textToSpeech);
      setStudentFileUpload(res.studentFileUpload);
      setAllowLangChange(res.allowLanguageChange);
      setCrAnswerToolType(res.crAnswerToolId);
      setIsTimed(res.timed);
      setTimeOnTaskEnabled(res.timeOnTask);
      setTimeOnTaskSeconds(res.period);
      setLockBrowser(res.lockBrowser);
      setPhotoMathBlock(res.photoMathBlock);
      setAutoStartCRUponGrading(res.autoStartCRUponGrading);
      setUseRuler(res.ruler);

      var fromDateTime = new Date();
      fromDateTime.setHours(1);
      fromDateTime.setMinutes(0);
      var toDateTime = new Date();
      toDateTime.setHours(23);
      toDateTime.setMinutes(59);
      setInitialFromValue(fromDateTime);
      setInitialToValue(toDateTime);

      const hours = Math.floor(res.timeSpan / 60); // Calculate the number of hours
      const minutes = res.timeSpan % 60; // Calculate the remaining minutes

      setTimedHour(hours);
      setTimedMinute(minutes);
    } catch (err) {
      //Testing
    }
  };

  const resetActivitySettings = () => {
    context.setActivityMode(activitySettings.flashcardMode);
    context.setAvailabilityOption(activitySettings.availability);
    context.setStartDate(activitySettings.startDate);
    context.setEndDate(activitySettings.endDate);
    context.setTextToSpeech(activitySettings.textToSpeech);
    context.setStudentFileUpload(activitySettings.studentFileUpload);
    context.setRandomized(activitySettings.randomize);
  };

  const resetAssignmentSettings = () => {
    if (!assignmentSettingsResult.isSuccess) return;

    var assignmentMode = assignmentSettingsResult.data.assignmentMode.toLowerCase().includes('quiz')
      ? 'quiz'
      : 'open';
    context.setAssignmentMode(assignmentMode);
    context.setAvailabilityOption(assignmentSettingsResult.data.availability);
    context.setAutoLockQuestions(assignmentSettingsResult.data.autoLockQuestions);
    context.setAllowAnswerChange(assignmentSettingsResult.data.allowAnswerChange);
    context.setAllowLangChange(assignmentSettingsResult.data.allowLanguageChange);
    context.setShowGrade(assignmentSettingsResult.data.showGrade);
    context.setRetakesEnabled(assignmentSettingsResult.data.assignRetake);
    context.setMasteryValue(assignmentSettingsResult.data.masteryLevel);
    context.setRetakeLimitValue(assignmentSettingsResult.data.retakeLimit);
    context.setIncludeCR(assignmentSettingsResult.data.includeCR);
    context.setUseProtractor(assignmentSettingsResult.data.useProtractor);
    context.setUseRuler(assignmentSettingsResult.data.useRuler == 1 ? true : false);
    context.setCalculatorEnabled(assignmentSettingsResult.data.useCalc);
    context.setCalculatorType(assignmentSettingsResult.data.calculatorType);
    context.setTextToSpeech(assignmentSettingsResult.data.textToSpeech);
    context.setStudentFileUpload(assignmentSettingsResult.data.studentFileUpload);
    context.setCrAnswerToolType(assignmentSettingsResult.data.crAnswerToolId);
    context.setIsTimed(assignmentSettingsResult.data.timed);
    context.setTimeOnTaskEnabled(assignmentSettingsResult.data.timeOnTask);
    context.setTimeOnTaskSeconds(assignmentSettingsResult.data.period);
    context.setLockBrowser(assignmentSettingsResult.data.lockBrowser);
    context.setPhotoMathBlock(assignmentSettingsResult.data.photoMathBlock);
    context.setAutoStartCRUponGrading(
      assignmentSettingsResult.data.autoStartCRUponGrading
    );
    context.setStartDate(assignmentSettingsResult.data.startDate);
    context.setEndDate(assignmentSettingsResult.data.endDate);
    context.setTimedHour(Math.floor(assignmentSettingsResult.data.timeSpan / 60));
    context.setTimedMinute(assignmentSettingsResult.data.timeSpan % 60);
  };

  const changeModeHandler = async () => {
    if (timedHour === 0 && timedMinute === 0 && isTimed) {
      CustomToast('Please enter a valid time span', 'error');
      return;
    }
    if (startDate === undefined) {
      CustomToast('Please enter a valid From date', 'error');
      setShowConfirmModal(false);
      setDisableButton(false);
      return;
    }
    if (endDate === undefined) {
      CustomToast('Please enter a valid To date', 'error');
      setShowConfirmModal(false);
      setDisableButton(false);
      return;
    }
    setDisableButton(true);
    const timeSpan = parseInt(context.timedHour) * 60 + parseInt(context.timedMinute);
    const isFlashCard = activityType == ActivityTypes.FlashCard;
    
    const value = {
      students: [{ studentId: -1, classId: 1 }],
      selfAssign: true,
      startDate: moment(isFlashCard ? context.startDate : startDate).format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment(isFlashCard ? context.endDate : endDate).format('YYYY-MM-DD HH:mm:ss'),
      activity: isFlashCard ? 2 : 1,
      ...(isFlashCard ? {
        assignmentMode: context.activityMode,
        availability: context.availabilityOption,
        studentFileUpload: context.studentFileUpload,
        textToSpeech: context.textToSpeech,
        randomize: context.randomized
      } : {
        displayDeleted: false,
        allowAnswerChange: allowAnswerChange,
        showGrade: showGrade,
        assignmentMode: assignmentMode,
        availability: availabilityOption,
        timed: isTimed,
        timeSpan: timeSpan,
        autoLockQuestions: context.autoLockQuestions,
        allowLanguageChange: context.allowLangChange,
        useCalc: context.calculatorEnabled ? 1 : 0,
        useProtractor: context.useProtractor ? 1 : 0,
        useRuler: context.useRuler ? 1 : 0,
        timeOnTask: context.timeOnTaskEnabled,
        period: context.timeOnTaskSeconds,
        practice: false,
        assignRetake: context.retakesEnabled,
        masteryLevel: context.masteryValue,
        retakeLimit: context.retakeLimitValue,
        retakeMode: context.retakeMode,
        retakeQuestions: context.retakeQuestion,
        includeCR: context.includeCR,
        retakeAvailability: context.retakeAvailabilty,
        retakeStartDate: context.startDate,
        retakeEndDate: context.endDate,
        retakeTimed: context.isTimed,
        retakeTimeSpan: timeSpan,
        showIdentificationFields: false,
        retakeRetries: context.scoreRetries,
        studentPrinting: false,
        StudentFileUpload: studentFileUpload,
        lockBrowser: lockBrowser,
        photoMathBlock: photoMathBlock,
        autoStartCRUponGrading: autoStartCRUponGrading,
        ruler: useRuler ? 1 : 0,
        crAnswerToolId: crAnswerToolType,
        calculatorType: calculatorType
      })
    };

    const options = {
      assignmentId: assignmentId,
      data: value
    };
    try {
      await changeMode(options).unwrap();
      await getAssignmentSettingsDetails(assignmentId).unwrap();
      CustomToast(`${activityType == ActivityTypes.Assignment ? 'Assignment' : 'FlashCard'} mode changed successfully`, 'success');
      setShowConfirmModal(false);
      setDisableButton(false);
    } catch (err) {
      CustomToast(err.data, 'error');
      setShowConfirmModal(false);
      setDisableButton(false);
    }
  };

  const handleAssignToSelf = async () => {
    const options = {
      assignmentId: assignmentId
    };
    try {
      await assignToSelf(options).unwrap();
      setAssignToMyself(!assignToMyself);
      setReassignToMyself(true);
      CustomToast('Assigned to you in Open mode', 'success');
      await getAssignmentSettingsDetails(assignmentId).unwrap();
    } catch (err) {
      if (err.originalStatus === 400) {
        CustomToast(`${err.data}`, 'error');
      }
    }
  };

  const handleUnassignToSelf = async () => {
    const options = {
      assignmentId: assignmentId
    };
    try {
      setDisableButton(true);
      await unAssignFromMe(options).unwrap();
      setDisableButton(false);
      setShowConfirmModal(false);
      setAssignToMyself(!assignToMyself);
      setReassignToMyself(false);
      CustomToast('Unassigned from you', 'success');
    } catch (err) {
      setDisableButton(false);
      setShowConfirmModal(false);
    }
  };

  const handleReAssignConfirm = () => {
    setConfirmModalMessage(
      `Are you sure that you want to reassign this ${activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} to yourself? By reassigning, answers in your session are cleared.`
    );
    setConfirmModalTitle('Reassign To Self');
    confirmModalCallbackRef.current = handleReAssignMyself;
    setShowConfirmModal(true);
  };

  const handleUnassignConfirm = () => {
    setConfirmModalMessage(
      `Are you sure that you want to unassign this ${activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} from yourself? You will be able to reassign it to yourself again.`
    );
    setConfirmModalTitle('Unassigned From Self');
    confirmModalCallbackRef.current = handleUnassignToSelf;
    setShowConfirmModal(true);
  };

  const handleChangeModeConfirm = () => {
    if (context.availabilityOption == 'FromTo') {
      const currentDate = moment().format('YYYY/MM/DD h:mm A'); // Get the current date/time
      if(moment(context.startDate).isBefore(currentDate, 'day')){
        CustomToast('From Date must not be before the current day', 'error');
        return;
      }
      if(moment(context.endDate).isBefore(currentDate)){
        CustomToast('To Date must not be before the current date/time', 'error');
        return;
      }
      if(moment(context.endDate).isBefore(moment(context.startDate)) || moment(context.endDate).isSame(moment(context.startDate))){
        CustomToast('To Date must be after the From Date', 'error');
        return;
      }
    }
    
    setConfirmModalMessage(`<center>Are you sure you want to change the ${activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} mode to <br /> 
    <b>"${capitalizeFirstLetter(assignmentMode)} 
    ${isTimed ? 'Timed' : ''} 
    
    ${availabilityOption === 'FromTo'
    ? `${startDate !== undefined ? moment(startDate).format('DD/MM/y h:mm A') + ' - ' : ''}
      ${endDate !== undefined ? moment(endDate).format('DD/MM/y h:mm A') : ''}`
    : ''}
    "</b>
    <br /> for this ${activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} to you?</center>`);
    setConfirmModalTitle('Change Mode');
    confirmModalCallbackRef.current = changeModeHandler;
    setShowConfirmModal(true);
  };

  const handleReAssignMyself = () => {
    if (assignToMyself) {
      const options = {
        assignmentId: assignmentId
      };
      try {
        setDisableButton(true);
        reAssignToSelf(options).unwrap();
        setDisableButton(false);
        setShowConfirmModal(false);
        activityType == ActivityTypes.FlashCard ? context.setActivityMode('open') : context.setAssignmentMode('open');
        CustomToast('Reassigned to you in Open mode', 'success');
      } catch (err) {
        setDisableButton(false);
        setShowConfirmModal(false);
      }
    }
  };

  return (
    <>
      <div className="white-card mb-4">
        <div className="col-12 info-text d-flex align-items-center">
          <span className="flex-shrink-0">
            <FontAwesomeIcon icon={faInfo} />
          </span>
          {!assignToMyself && (
            <p>
              Assign to self to view like a student or use for a class review with your projector
              and screen. Use the <strong>Student Center</strong> link found in your Teacher Center
              to see {activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'}. To assign to students, use Assign to Students or Quick Assign.
            </p>
          )}
          {assignToMyself && (
            <p>
              This {activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} is currently assigned to you. You can access this {activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} by
              selecting <strong>Student Center</strong>. If you have made changes to the {activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} Mode and wish to keep them, then you can change the mode.
              or if you wish to clear your answers, then you can reassign it to yourself.
            </p>
          )}
        </div>
        <div className="d-flex gap-3 mt-4 flex-wrap align-items-center">
          {!assignToMyself && (
            <div onClick={handleAssignToSelf} className="self-assign-card">
              <FontAwesomeIcon icon={faUserPlus} />
              Assign to myself
            </div>
          )}
          {assignToMyself && (
            <div onClick={handleUnassignConfirm} className="self-assign-card">
              <FontAwesomeIcon icon={faUserMinus} />
              Unassign from myself
            </div>
          )}
          <OverlayTrigger
            key="tooltip-reassign"
            placement="top"
            overlay={
              <Tooltip id="reassign-info" className="custom-tooltip">
                <p>
                  Reassign to myself in Open mode. After reassigning, use Change Mode if desired.
                </p>
              </Tooltip>
            }>
            <div
              onClick={handleReAssignConfirm}
              className={`self-assign-card ${
                !reassignToMyself && 'disabled disable-Pointer-Events'
              }`}>
              <FontAwesomeIcon icon={faUserCheck} />
              Reassign to myself
            </div>
          </OverlayTrigger>
        </div>
      </div>

      <div className="white-card self-assign-settings mb-4">
        {assignToMyself && !assignmentSettingsResult.isFetching && (
          <>
            {activityType == ActivityTypes.Assignment ?(
              <AssignmentSettings
                allowRetakesOption={false}
                twoColumn={true}
                reviewOnlyRadio={true}
                lockedRadio={true}
                randomizedQuestion={false}
                disabledTextSpeach={false}
                presetSettingsCallback={resetAssignmentSettings}
                allowOfflineMode={true}
                isSelfAssign={true}
              />
            ):(
              <ActivitySettings
                twoColumn={true}
              />
            ) }
            
            <div className="d-flex justify-content-end gap-3">
              <button onClick={() => activityType == ActivityTypes.Assignment ? resetAssignmentSettings() : resetActivitySettings()} className="btn btn-width btn-castleWhite">
                Cancel
              </button>
              <button onClick={handleChangeModeConfirm} className="btn btn-castleRed">
                Change Mode
              </button>
            </div>
          </>
        )}
      </div>
      {assignToMyself && (
        <div className="col-12 info-text d-flex align-items-start">
          <span className="flex-shrink-0">
            <FontAwesomeIcon icon={faInfo} />
          </span>
          <p>
            <strong>Note:</strong> The {activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} Mode for the self-assigned {activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} is separate
            from the {activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} Mode for your students. Setting the {activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} Mode on this page
            only affects the {activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'} made to you, which you can access by clicking the Student
            Center link on the Teacher Center. Use the other tabs - {activityType == ActivityTypes.Assignment ? 'Assignment' : 'Flashcard'} To Students, Quick
            Assign, and {activityType == ActivityTypes.Assignment ? 'Assignment' : 'Flashcard'} Results (for modifying the mode) - to set/modify the {activityType == ActivityTypes.Assignment ? 'assignment' : 'flashcard'}
            Mode for your students.
          </p>
        </div>
      )}

      <ConfirmModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirmCallback={confirmModalCallbackRef.current}
        contentWidth={'50%'}
        titleName={confirmModalTitle}
        setDisableButton={setDisableButton}
        disableButton={disableButton}
        messageContent={confirmModalMessage}
      />
    </>
  );
};

SelfAssign.propTypes = {
  assignmentId: PropTypes.number.isRequired,
  assignToMyself: PropTypes.bool.isRequired,
  setAssignToMyself: PropTypes.func.isRequired,
  reassignToMyself: PropTypes.bool.isRequired,
  setReassignToMyself: PropTypes.func.isRequired
};

export default SelfAssign;
